import { render, staticRenderFns } from "./UiLoader.vue?vue&type=template&id=a6e11ec8&scoped=true&"
import script from "./UiLoader.vue?vue&type=script&lang=js&"
export * from "./UiLoader.vue?vue&type=script&lang=js&"
import style0 from "./UiLoader.vue?vue&type=style&index=0&id=a6e11ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e11ec8",
  null
  
)

export default component.exports